import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { financecommerceApi } from '../../api/financecommerce';

export function FinanceAnalyticsPage() {
  const [profit, setProfit] = useState<{ revenue: number; net_profit: number; margin_pct: number } | null>(null);

  useEffect(() => {
    void financecommerceApi.profitability().then(setProfit);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/finance" className="text-sm text-slate-600 hover:underline">← Finance hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Financial analytics</h1>
      {profit && (
        <div className="mt-6 grid gap-4 sm:grid-cols-3">
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">Revenue</p><p className="text-xl font-semibold">₹{profit.revenue.toFixed(0)}</p></div>
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">Net profit</p><p className="text-xl font-semibold">₹{profit.net_profit.toFixed(0)}</p></div>
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">Margin</p><p className="text-xl font-semibold">{profit.margin_pct.toFixed(1)}%</p></div>
        </div>
      )}
    </div>
  );
}
